// Inline stroke icon set (Lucide-derived paths) + the gradient-stroke treatment.
import { useRef, type CSSProperties } from 'react';

export const CRW_ICONS = {
  search: 'm21 21-4.34-4.34|M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16',
  play: 'm6 3 14 9-14 9z',
  folder: 'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z',
  drive: 'M22 12H2|M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z|M6 16h.01|M10 16h.01',
  image: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z|m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21|M9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
  sparkle: 'M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z',
  mic: 'M12 19v3|M19 10v2a7 7 0 0 1-14 0v-2|M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z',
  text: 'M17 6.1H3|M21 12.1H3|M15.1 18H3',
  user: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2|M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2|M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8|M22 21v-2a4 4 0 0 0-3-3.87|M16 3.13a4 4 0 0 1 0 7.75',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20|M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20|M2 12h20',
  check: 'M20 6 9 17l-5-5',
  x: 'M18 6 6 18|m6 6 12 12',
  plus: 'M5 12h14|M12 5v14',
  minus: 'M5 12h14',
  arrowRight: 'M5 12h14|m12 5 7 7-7 7',
  download: 'M12 15V3|M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4|m7 10 5 5 5-5',
  zap: 'M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z',
  lock: 'M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z|M7 11V7a5 5 0 0 1 10 0v4',
  cpu: 'M12 20v2|M12 2v2|M17 20v2|M17 2v2|M2 12h2|M2 17h2|M2 7h2|M20 12h2|M20 17h2|M20 7h2|M7 20v2|M7 2v2|M4 4h16v16H4z|M8 8h8v8H8z',
  brain: 'M12 18V5|M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4|M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5|M17.997 5.125a4 4 0 0 1 2.526 5.77|M18 18a4 4 0 0 0 2-7.464|M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517|M6 18a4 4 0 0 1-2-7.464|M6.003 5.125a4 4 0 0 0-2.526 5.77',
  shield: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1 1 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z',
  infinity: 'M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8',
  tag: 'M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z|M7.5 7.5h.01',
  monitor: 'M20 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z|M8 21h8|M12 17v4',
  film: 'M7 3v18|M3 7.5h4|M3 12h18|M3 16.5h4|M17 3v18|M17 7.5h4|M17 16.5h4|M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z',
  layers: 'M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z|m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65|m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65',
  scissors: 'M9.5 7.5 16 14|M9.5 16.5 21 5|M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z|M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  refresh: 'M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8|M21 3v5h-5|M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16|M8 16H3v5',
  message: 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z',
  pen: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z',
  bot: 'M12 8V4H8|M2 14h2|M20 14h2|M15 13v2|M9 13v2|M20 8H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z',
  apple: 'M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z|M10 2c1 .5 2 2 2 5',
  gear: 'M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z|M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  help: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20|M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3|M12 17h.01',
  camera: 'M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z|M12 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  ban: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20|m4.9 4.9 14.2 14.2',
  chevdown: 'm6 9 6 6 6-6',
  at: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8|M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8',
  eye: 'M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0|M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  grid: 'M3 3h7v7H3z|M14 3h7v7h-7z|M14 14h7v7h-7z|M3 14h7v7H3z',
  sliders: 'm21 4-7 0|M10 4H3|M21 12h-9|M8 12H3|M21 20h-5|M12 20H3|M14 2v4|M8 10v4|M16 18v4',
  toLine: 'M17 12H3|m11 18 6-6-6-6|M21 5v14',
  downToLine: 'M12 17V3|m6 11 6 6 6-6|M19 21H5',
  wand: 'm21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72|m14 7 3 3|M5 6v4|M19 14v4|M10 2v2|M7 8H3|M21 16h-4|M11 3H9',
  menu: 'M4 5h16|M4 12h16|M4 19h16',
} as const;

export type IconName = keyof typeof CRW_ICONS;

export interface IconProps {
  d: IconName;
  size?: number;
  sw?: number;
  style?: CSSProperties;
}

export function CRWIcon({ d, size = 16, sw = 1.75, style }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}>
      {CRW_ICONS[d].split('|').map((p, i) => <path key={i} d={p} />)}
    </svg>
  );
}

let gradIconId = 0;
// Custom gradient-stroked icon (dawn-high to dawn).
export function GradIcon({ d, size = 17, sw = 1.7 }: IconProps) {
  const id = useRef(`crwg${++gradIconId}`).current;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={`url(#${id})`} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: 'var(--dawn-high)' }} />
          <stop offset="1" style={{ stopColor: 'var(--dawn)' }} />
        </linearGradient>
      </defs>
      {CRW_ICONS[d].split('|').map((p, i) => <path key={i} d={p} />)}
    </svg>
  );
}

// Glass icon tile with gradient icon + soft halo.
export function IconTile({ d, size = 38 }: { d: IconName; size?: number }) {
  return (
    <span className="crw-icontile" style={{ width: size, height: size }}>
      <GradIcon d={d} size={Math.round(size * 0.46)} />
    </span>
  );
}
